// Shared category metadata used by both public Blog UI and (implicitly) the
// admin editor category selector. Backend accepts any category slug; these
// are only used for display.
export const CATEGORIES = {
    "estate-planning": { label: "Estate Planning", color: "#C82828" },
    "elder-law": { label: "Elder Law", color: "#6E5A3B" },
    "real-estate": { label: "Real Estate", color: "#A8815C" },
    "business-law": { label: "Business Law", color: "#3F4B5A" }
};

export function formatDate(iso) {
    if (!iso) return "";
    const d = new Date(iso);
    return d.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });
}

export function CategoryBadge({ category }) {
    const c = CATEGORIES[category] || { label: category, color: "#3F4B5A" };
    return (
        <span
            className="inline-flex items-center text-[10px] uppercase tracking-[0.25em] px-3 py-1.5 border"
            style={{ color: c.color, borderColor: c.color }}
        >
            {c.label}
        </span>
    );
}
